(function () {
  'use strict';

  function NewAddressesCtrl (newAddressFactory, $timeout, $scope, $filter) {
    const vm = this;

    // this is only limited to two choices
    function selectRadio (selected, inactive) {
      vm[ selected ] = true;
      vm[ inactive ] = false;
    }

    // TODO: move this to factory
    function checkModels (models) {
      let allVal = true;

      models.forEach(function (item) {
        if (item.modelKey !== 'all' && !item.selected) {
          allVal = false;
        }
      });

      models[ 0 ].selected = allVal;
    }

    // TODO: move this on factory
    function selectModel (model, groupKey) {
      if (model.modelKey === 'all') {
        vm[ groupKey ].forEach(function (item) {
          if (item.modelKey !== 'all') {
            item.selected = vm[ groupKey ][ 0 ].selected;
          }
        });
      } else {
        vm.checkModels(vm[ groupKey ]);
      }

    }

    function showFormClicked () {
      if (vm.showArea) {
        vm.showForm = !vm.showForm;
      }
    }

    function showAreaClicked () {
      vm.showArea = !vm.showArea;

      if (!vm.showArea) {
        vm.showForm = false;
      }
    }

    function refreshSlider () {
      $timeout(function () {
        $scope.$broadcast('rzSliderForceRender');
      });
    }

    function activate () {
      // models
      vm.adr = true;
      vm.odr = false;
      vm.showArea = false;
      vm.showForm = false;
      vm.gender = '';
      vm.individualBusiness = '';

      vm.householdTypes = newAddressFactory.householdTypes;
      vm.lodging = newAddressFactory.lodging;

      vm.slider = {
        'min': 1,
        'max': 10,
        'options': {
          'floor': 1,
          'ceil': 10,
          'step': 1,
          'noSwitching': true,
          'showTicks': true,
          'translate': function (value, id, label) {
            let labelPrefix;

            if (label === 'model') {
              labelPrefix = $filter('translate')('LOW');
              labelPrefix = labelPrefix + ' ' + value;
            } else if (label === 'high') {
              labelPrefix = $filter('translate')('HIGH');
              labelPrefix = labelPrefix + ' ' + value;
            } else {
              labelPrefix = value;
            }

            return labelPrefix;
          }
        }
      };

      // methods
      vm.selectRadio = selectRadio;
      vm.selectModel = selectModel;
      vm.checkModels = checkModels;
      vm.showFormClicked = showFormClicked;
      vm.showAreaClicked = showAreaClicked;
      vm.refreshSlider = refreshSlider;

      console.log('NewAddressesCtrl activated');
    }

    activate();
  }

  angular.module('web2print.newAddress')
    .controller('NewAddressesCtrl', NewAddressesCtrl);

  NewAddressesCtrl.$inject = [ 'newAddressFactory', '$timeout', '$scope', '$filter' ];
})();
